

const TabularDataRetailerCell = ({ trend, retailerKey, time }) => {

  return <div className="w-full h-full flex flex-wrap justify-center ">
    <p>{trend.retailerTimeCount && trend.retailerTimeCount[retailerKey] ? trend.retailerTimeCount[retailerKey] : 0} products</p>
    {trend.retailerTimeCounts && trend.retailerTimeCounts[retailerKey] ? trend.retailerTimeCounts[retailerKey].map(r => r.count > 0 ? <p className="text-center font-semibold  w-full shrink-0 ">{r.count} {r.retailer} Products </p> : null) : null}
    {trend.retailerImages ? trend.retailerImages.filter(img => new Date(img.insertDate) >= time).slice(0, 4).map(image => <div className="w-28 h-48 p-0.5 flex justify-center items-start max-w-[50%]" key={image.pk}>
      <img src={image.imageUrl} className='max-w-full max-h-full object-contain' loading="lazy" />
    </div>) : null}
  </div>
}

export default TabularDataRetailerCell
